<template>
  <section class="appointment__index column-index">
    <change-store></change-store>
    <column-info :column-list="columnListDefault"></column-info>
  </section>
</template>

<script>
import ChangeStore from '../components/ChangeStore'
import ColumnInfo from '../components/ColumnInfo'

export default {
  components: {
    ChangeStore,
    ColumnInfo
  },
  data() {
    return {
      addAuth: true,
      columnList: [
        // 审核
        {
          title: '养修预约',
          hasAuth: true,
          items: [
            {
              name: '今日预约 ',
              icon: 'appointment-today',
              link: '/appointment/list/type/today'
            },
            {
              name: '全部预约 ',
              icon: 'appointment-all',
              link: '/appointment/list/type/all'
            },
            {
              name: '每日简报 ',
              icon: 'appointment-daily',
              link: '/appointment/daily'
            }
          ]
        },
        {
          hasAuth: true,
          authName: 'show_entrance',
          title: '定保招揽',
          items: [
            {
              slotClass: true,
              name: '保养日期试算 ',
              icon: 'maintenance-trial',
              link: '/maintenance/trial'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.setColumnAuth()
  },
  methods: {
    async setColumnAuth () {
      const { data, code } = await this.$rest.appointment.getAutoSolutionRule3()
      if (code !== 0) {
        this.showToast(message)
        return
      }
      this.columnList.forEach((item, index) => {
        if (item.authName === 'show_entrance') {
          item.hasAuth = data.show_entrance
        }
      })
    }
  },
  computed: {
    columnListDefault () {
      return this.columnList.filter(column => column.hasAuth === true)
    }
  },
  mounted () {
    this.$store.state.promiseAuth.then(auth => {
      this.addAuth = auth.isPendingConfirm
      if (this.addAuth) {
        this.columnList[0].items.unshift({
          name: '新增预约 ',
          icon: 'appointment-confirm',
          link: '/appointment/newAppointment'
        })
      }
    })
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn.less";
  @import "../../stylesheets/modules/manage/columnList.less";
  .appointment__index {
    .column {
      @selectors: appointment-confirm, appointment-today, appointment-all, appointment-daily, maintenance-trial;
      each(@selectors, {
        .@{value} {
          background: url('../../stylesheets/images/index/@{value}.png') no-repeat center center / cover;
          background-size: contain;
        }
      })
    }
  }
</style>
